import React from 'react';
import { TableWrapper } from './TableWrapper';
interface TungPointsTabProps {
  searchTerm: string;
}
export function TungPointsTab({
  searchTerm
}: TungPointsTabProps) {
  const tungPoints = [{
    name: 'Linggu (T 22.05)',
    location: 'On the radial side of the index finger, in the depression proximal to the 1st metacarpal bone, between the red and white skin. Approximately at LI-4 location.',
    indications: 'Low back pain, sciatica, headache, neck pain, eye problems, toothache, facial paralysis, hemiplegia',
    needling: '0.5-1 cun perpendicular insertion. Strong stimulation. Contraindicated in pregnancy.',
    notes: 'One of the most important Master Tung points. Part of the famous "Linggu Dabai" combination for sciatica.'
  }, {
    name: 'Dabai (T 22.04)',
    location: 'On the radial side of the index finger, in the depression between the 1st and 2nd metacarpal bones, proximal to LI-3.',
    indications: 'Sciatica, low back pain, fever, asthma, pediatric disorders, neck pain',
    needling: '0.3-0.5 cun perpendicular insertion.',
    notes: 'Used together with Linggu for the famous sciatica protocol.'
  }, {
    name: 'Zhongbai (T 22.06)',
    location: 'On the dorsum of the hand, between the 2nd and 3rd metacarpal bones, proximal to the web margin, approximately at TH-3 location.',
    indications: 'Low back pain (especially L2-L3), edema, sciatica, shoulder pain',
    needling: '0.3-0.5 cun perpendicular insertion.',
    notes: 'Particularly effective for L2-L3 lumbar problems.'
  }, {
    name: 'Shoujingdian (T 22.19)',
    location: 'On the dorsum of the hand, at the junction of the 2nd and 3rd metacarpal bones, in the depression distal to TH-3.',
    indications: 'Neck pain, cervical problems, stiff neck, occipital headache',
    needling: '0.3-0.5 cun perpendicular insertion. Needle contralateral side.',
    notes: 'Specific for Shao Yang and Tai Yang neck pain. Use healthy side only.'
  }, {
    name: 'Mu Huo (Wood Fire)',
    location: 'At the DIP joint of the middle finger, on the radial side of the extensor tendon.',
    indications: 'Paralysis, hemiplegia, motor dysfunction, stroke recovery',
    needling: '0.1-0.2 cun oblique insertion toward the tip. Use special protocol.',
    notes: 'Part of special protocol for paralysis. Bleed the point for best results.'
  }, {
    name: 'Chung Tze & Chung Hsien (T 66.09-10)',
    location: 'On the palmar surface of the index finger, on either side of the PIP joint.',
    indications: 'Upper back pain, thoracic pain, asthma, breathing difficulties, chest tightness',
    needling: '0.2-0.3 cun perpendicular insertion bilaterally.',
    notes: 'Excellent for thoracic spine and respiratory issues.'
  }, {
    name: 'Ba Guan (Eight Passes) (T 77.21-28)',
    location: 'Eight points on the dorsum of the foot, between the metatarsal bones, forming four pairs.',
    indications: 'Motor and sensory deficit of lower limbs, paralysis, stroke, weakness in legs',
    needling: '0.5-1 cun oblique insertion toward the ankle.',
    notes: 'Powerful points for lower extremity paralysis and motor dysfunction.'
  }, {
    name: 'Gan Men (Liver Gate) (T 77.18)',
    location: 'On the dorsum of the foot, between the 1st and 2nd metatarsal bones, 1.5 cun proximal to the web margin.',
    indications: 'Liver disease, hepatitis, elevated liver enzymes, liver inflammation, liver qi stagnation',
    needling: '0.5-1 cun perpendicular insertion.',
    notes: 'Specific point for all liver-related conditions.'
  }, {
    name: 'Yen Huang (T 77.17)',
    location: 'On the dorsum of the foot, between the 2nd and 3rd metatarsal bones, 1.5 cun proximal to the web margin.',
    indications: 'Hepatitis, jaundice, liver inflammation, bile problems, gallbladder disorders',
    needling: '0.5-1 cun perpendicular insertion.',
    notes: 'Often combined with Gan Men for liver and gallbladder conditions.'
  }, {
    name: 'Mu Guan & Gu Guan (T 77.23-24)',
    location: 'On the dorsum of the foot, between the 4th and 5th metatarsal bones.',
    indications: 'Swollen joints, arthritis, heel pain, plantar fasciitis, bone spurs',
    needling: '0.5-1 cun perpendicular insertion.',
    notes: 'Specific for joint swelling and bone problems.'
  }, {
    name: 'Tianhuangfu (T 77.18)',
    location: 'On the lateral aspect of the lower leg, in the GB channel.',
    indications: 'Bone diseases, fractures, osteoporosis, bone pain, bone spurs',
    needling: '1-1.5 cun perpendicular insertion.',
    notes: 'Master point for all bone-related disorders.'
  }, {
    name: 'Sanjian (Three Spaces)',
    location: 'Three points on the dorsum of the hand between metacarpal bones.',
    indications: 'Shoulder pain, upper back pain, neck pain, arm pain, hand disorders',
    needling: '0.3-0.5 cun perpendicular insertion.',
    notes: 'Effective for upper body musculoskeletal problems.'
  }, {
    name: 'Wanshunyi & Wanshunii (T 22.07-08)',
    location: 'On the radial side of the thumb, near the MCP joint.',
    indications: 'Nausea, vomiting, motion sickness, morning sickness',
    needling: '0.2-0.3 cun perpendicular insertion.',
    notes: 'Immediate relief for nausea and vomiting.'
  }, {
    name: 'Zhongjiufen (T 88.14)',
    location: 'On the posterior thigh, in the BL channel area.',
    indications: 'Sciatica, lower back pain, hip pain, leg pain',
    needling: '1-2 cun perpendicular insertion.',
    notes: 'Powerful point for sciatic nerve pain.'
  }];
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-860">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-861">
        Master Tung's Extraordinary Points
      </h2>
      <p className="mb-6 text-gray-700" data-id="element-862">
        <strong data-id="element-863">
          Detailed information on Master Tung's most powerful acupuncture points
        </strong>
      </p>
      <TableWrapper searchTerm={searchTerm} data-id="element-864">
        <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-865">
          <thead data-id="element-866">
            <tr className="bg-gradient-to-r from-purple-600 to-purple-800 text-white" data-id="element-867">
              <th className="p-4 text-left text-sm font-semibold" data-id="element-868">
                Point Name
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-869">Location</th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-870">
                Indications
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-871">
                Needling Technique
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-872">
                Clinical Notes
              </th>
            </tr>
          </thead>
          <tbody data-id="element-873">
            {tungPoints.map((point, index) => <tr key={index} className="border-b border-gray-200 hover:bg-blue-50 transition-colors even:bg-gray-50" data-id="element-874">
                <td className="p-3 font-semibold text-gray-800" data-id="element-875">
                  {point.name}
                </td>
                <td className="p-3 text-green-700" data-id="element-876">{point.location}</td>
                <td className="p-3 text-purple-700" data-id="element-877">{point.indications}</td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-878">
                  {point.needling}
                </td>
                <td className="p-3 text-purple-700 italic" data-id="element-879">{point.notes}</td>
              </tr>)}
          </tbody>
        </table>
      </TableWrapper>
    </div>;
}